// extracted by mini-css-extract-plugin
export default {"root":"SidebarPopup_root__MHKHH","closeButton":"SidebarPopup_closeButton__HznUL"};